var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.productQualityParameters),function(parameter){return _c('offer-edit-specific-quality-parameter',{key:'EDIT_PARAMETER_' + parameter.id,attrs:{"form":_vm.form,"parameter":parameter}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }